import type { ParsedSheet } from '@cobliteam/hooks/src/useSpreadsheetParser';
import type { FileMetadata } from '@cobliteam/ui/components/FileUpload';
import type { StateCreator } from 'zustand';
import type { ImportColumnDef, SelectedColumns } from '../../types';

interface SheetImportSliceState {
  columns: ImportColumnDef[];
  selectedColumns: SelectedColumns;
  isAllRequiredFieldsFilled?: boolean;
  sheetModelUrl: string;
  sheetMetaData: FileMetadata[];
  sheetTab: ParsedSheet | undefined;
  headerRow: { key: string; value: number } | undefined;
  disableNextStep: boolean;
  setColumns: (columns: ImportColumnDef[]) => void;
  setSelectedColumns: (selectedColumns: SelectedColumns) => void;
  setIsAllRequiredFieldsFilled: (isFilled: boolean) => void;
  setSheetModelUrl: (url: string) => void;
  setSheetMetaData: (files: FileMetadata[]) => void;
  setSheetTab: (tab: ParsedSheet | undefined) => void;
  setHeaderRow: (row: { key: string; value: number } | undefined) => void;
  setDisabledNextStep: (disable: boolean) => void;
  clearSelections: () => void;
}

type StateCreatorSheetImport = StateCreator<SheetImportSliceState, [['zustand/devtools', never]], [], SheetImportSliceState>;

const createSheetImportSlice: StateCreatorSheetImport = (set) => ({
  columns: [],
  selectedColumns: {
    supplierName: [],
    observation: [],
  },
  isAllRequiredFieldsFilled: false,
  sheetModelUrl: '',
  sheetMetaData: [],
  sheetTab: undefined,
  headerRow: undefined,
  disableNextStep: true,
  setColumns: (columns) =>
    set({
      columns: columns,
    }),
  setSelectedColumns: (selectedColumns) => set({ selectedColumns: selectedColumns }),
  setIsAllRequiredFieldsFilled: (isFilled) => set({ isAllRequiredFieldsFilled: isFilled }),
  setSheetModelUrl: (url) => set({ sheetModelUrl: url }),
  setSheetMetaData: (file) => set({ sheetMetaData: file }),
  setSheetTab: (tab) => set({ sheetTab: tab }),
  setHeaderRow: (row) => set({ headerRow: row }),
  setDisabledNextStep: (disable) => set({ disableNextStep: disable }),
  clearSelections: () =>
    set({
      selectedColumns: {},
      sheetTab: undefined,
      headerRow: undefined,
      sheetMetaData: [],
      disableNextStep: true,
    }),
});

export type { SheetImportSliceState };
export default createSheetImportSlice;
